<!-- App Main Structure -->
<template>
  <div class="app-default-layout">
    <template>
      <notifications group="aps" position="bottom center"/>
      <!-- App Header -->
      <app-header ></app-header>
      <!-- App Main Content -->
      <v-content   >
        <v-layout  row wrap>
          <v-flex xs12 sm2 md1 v-if="backState">
           <!--  <v-btn flat icon :to="backState">
              <v-icon>arrow_back</v-icon>
            </v-btn> -->
          </v-flex>
          <v-flex  xs12 sm10 md11>
            <v-breadcrumbs class="justify-center" :items="pageBreadcrumb">
              <v-icon slot="divider">chevron_right</v-icon>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>

        <!-- App Router -->
        <transition  name="router-anim" enter-active-class="animated fadeIn">
          <router-view ></router-view>
        </transition>

        <!-- App Footer -->
        <app-footer></app-footer>
      </v-content>
    </template>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
export default {
  data() {
    return {};
  },
  computed: {
    // computed property to get page breadcrumbs
    backState() {
      return this.$breadcrumbs[0].meta.backState;
    },
    pageBreadcrumb() {
      return this.$breadcrumbs[0].meta.breadcrumb;
    }
  },
  components: {
    appHeader: Header,
    appFooter: Footer
  }
};
</script>

<style scoped>
